// 🔹 Normaliza el formato del RUT
export function sanitizeRut(raw = '') {
  const t = String(raw).trim().replace(/\./g, '').replace(/\s+/g, '')
  const hasDash = t.includes('-')
  if (!hasDash && t.length > 1) return `${t.slice(0, -1)}-${t.slice(-1)}`.toUpperCase()
  return t.toUpperCase()
}
